import { Component, OnInit } from '@angular/core';
import { Title, Meta } from "@angular/platform-browser";
import * as bootstrap from 'bootstrap';

declare var $: any


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'shangpenglab';

  navItems = [
    {
      title: 'Home',
      link: ''
    },
    {
      title: 'News',
      link: 'news'
    },
    {
      title: 'Team',
      link: 'team'
    },
    {
      title: 'Publications',
      link: 'publications'
    },
    {
      title: 'Teaching',
      link: 'teaching'
    },
    {
      title: 'Join Us !',
      link: 'join-us'
    }
  ]

  startYear = 2022
  currentYear = 0
  selected = 0

  navbarMenu = false

  constructor(
    private titleService: Title,
    private metaService: Meta
  ) { }

  ngOnInit(): void {
    this.currentYear = new Date().getFullYear()
    this.getCurrentRoute()

    // SEO
    this.metaService.addTags([
      {
        name: 'keyword',
        content: 'shangpeng lab, shangpeng sun, Bioresource Engineering, mcgill university, sensing technologies, AI-driven computational methodology, smart agriculture, high-quality food,  High-throughput plant, 3D point cloud, Spatio-temporal variation pattern, crop shoots and roots, Multi-source imaging data fusion, Agricultural robotics and automation, deep learning, computer vision, 3D modeling, ag-robots, digital agriculture, electric circuits and machines, instrumentation and control, simulation and modelling'
      },
      {
        name: 'description',
        content: 'develop and adopt innovative sensing technologies and AI-driven computational methodology for solving challenges in next-generation smart agriculture, improving the production of high-quality food in the face of the rapidly growing human population and global environmental change'
      }
    ])
  }

  // 路由跳转完成后，获取当前的路由
  getCurrentRoute() {
    let currentRoute = window.sessionStorage.getItem('currentRoute')
    this.navItems.forEach((element, index) => {
      if (currentRoute == element['link']) {
        this.selected = index
      }
    });
  }

  selectedNav(index) {
    this.selected = index
    // 把当前的route保存在浏览器的sessionStorage里
    window.sessionStorage.setItem('currentRoute', String(this.navItems[index].link))
  }

}
